import Model from '@/models/Model.js';

export const LECTURE = 'onsite-lecture';
export const LAB = 'lab';
export const OFFSITE_WITH_INSTRUCTOR = 'offsite-with-instructor';
export const OFFSITE_WITHOUT_INSTRUCTOR = 'offsite-without-instructor';
export const ONLINE = 'online';

export default class AttendanceScenario extends Model {
    static entity = 'attendance_scenarios';

    static modelName = 'AttendanceScenario';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            description: this.attr(null),
            coursekey_attendance_name: this.attr(null),
            deleted_at: this.attr(null),

            ...super.fields(),
        };
    }

    /**
     * Dropdown options for assigning a scenario: every active scenario, plus the one currently
     * assigned when it has been archived, so the selection still shows what the course uses.
     *
     * @param {number|string|null} currentId
     * @returns {Array<{ id: number, name: string }>}
     */
    static assignableOptions(currentId = null) {
        return this.all()
            .filter(
                scenario => !scenario.deleted_at || (currentId != null && Number(scenario.id) === Number(currentId))
            )
            .map(scenario => ({
                id: scenario.id,
                name: scenario.deleted_at ? `${scenario.name} (archived)` : scenario.name,
            }));
    }

    /**
     * Mirrors a row from the attendance scenario API into the store so open settings
     * dropdowns reflect a create, edit, archive, or restore without a reload.
     *
     * @param {{ id: number, name: string, description?: string|null, archived?: boolean, archived_at?: string|null }} row
     * @returns {Promise<void>}
     */
    static async syncFromRow(row) {
        const data = {
            id: row.id,
            name: row.name,
            description: row.description ?? null,
            deleted_at: row.archived ? row.archived_at || new Date().toISOString() : null,
        };

        if (this.find(row.id)) {
            await this.update({ where: row.id, data });
        } else {
            await this.insert({ data });
        }
    }
}
